import { gql } from '@apollo/client';

export const APPROVE_OR_REJECT_ORDER = gql`
  mutation ApproveOrRejectOrder($orderId: ID!, $choice: Boolean!) {
    approveOrRejectOrder(orderId: $orderId, choice: $choice) {
      __typename
      ... on ApproveOrRejectOrderSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
